<template>
    <div v-if="restaurants.length > 0" class="w-screen mx-auto" style="background: #E6F2F3;">
  <!--    Mobile Screen-->
  <div
    class="max-w-7xl h-full mx-6 md:hidden"
  >
    <div class="h-full pb-10">
      <div class="flex mb-10 ml-6 gap-x-4 md:ml-14">
        <h1 class="mt-16 mb-2 text-3xl">
          {{ headline }}
        </h1>
      </div>
      <carousel
        :items-to-show="1.1"
        :wrap-around="true"
      >
        <slide
          v-for="card in restaurants"
          :key="card"
        >
          <div class="h-full w-full rounded-lg mx-1">
            <div class="flex flex-col">
                <figure class="relative h-72">
                <navigation />
                <img
                    class="w-full h-full rounded-t-lg"
                    :src="card.media.length > 0 ? card.media[0].original_url : ''"
                    :alt="card.media.length > 0 ? card.media[0].name : ''"
                >
                </figure>
              <div class="bg-white rounded-b-lg">
                <h2 class="text-left ml-6 mt-4 text-2xl">
                  {{ card.name }}
                </h2>
                <div class="ml-6 mb-4 mt-3">
                  <p class="text-gray-600 flex items-center">
                    <svg
                      width="12"
                      height="13"
                      class="mr-2"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.75 3.27177C0.75 2.61242 1.27233 2.0779 1.91667 2.0779H10.0833C10.7277 2.0779 11.25 2.61242 11.25 3.27177V10.435C11.25 11.0944 10.7277 11.6289 10.0833 11.6289H1.91667C1.27233 11.6289 0.75 11.0944 0.75 10.435V3.27177Z"
                        fill="white"
                      />
                      <path
                        d="M3.66667 3.27177V0.884033M8.33333 3.27177V0.884033M3.08333 5.65952H8.91667M1.91667 11.6289H10.0833C10.7277 11.6289 11.25 11.0944 11.25 10.435V3.27177C11.25 2.61242 10.7277 2.0779 10.0833 2.0779H1.91667C1.27233 2.0779 0.75 2.61242 0.75 3.27177V10.435C0.75 11.0944 1.27233 11.6289 1.91667 11.6289Z"
                        stroke="#01798A"
                        stroke-width="1.3166"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <formatted-date-range :from="card.start" :to="card.end" />
                  </p>
                  <p class="text-gray-600 mt-3 flex items-center">
                    <svg
                      width="12"
                      height="13"
                      class="mr-2"
                      viewBox="0 0 12 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.30048 9.03628C8.88345 9.46304 8.11904 10.2453 7.4309 10.9494C6.6463 11.7523 5.35485 11.7522 4.57024 10.9493C3.89547 10.2588 3.14306 9.48883 2.70082 9.03628C0.878373 7.17134 0.878373 4.14768 2.70082 2.28274C4.52327 0.417798 7.47804 0.417798 9.30048 2.28274C11.1229 4.14768 11.1229 7.17134 9.30048 9.03628Z"
                        stroke="#01798A"
                        stroke-width="1.16667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.75065 5.65951C7.75065 6.64854 6.96715 7.45031 6.00065 7.45031C5.03415 7.45031 4.25065 6.64854 4.25065 5.65951C4.25065 4.67047 5.03415 3.86871 6.00065 3.86871C6.96715 3.86871 7.75065 4.67047 7.75065 5.65951Z"
                        stroke="#01798A"
                        stroke-width="1.16667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {{ card.place.area }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </slide>
        <template #addons>
          <pagination />
        </template>
      </carousel>
    </div>
  </div>
  <!--    Desktop-->
        <div
            class="hidden max-w-7xl h-full w-full mx-auto md:block"
            style="background: #E6F2F3;"
        >
            <div class="h-full pb-20">
                <div class="ml-14 mb-10 pt-20">
                    <h1 class="text-3xl">
                        {{ headline }}
                    </h1>
                </div>
                <div class="ml-14">
                    <div class=" h-full w-full rounded-lg">
                        <carousel :items-to-show="1.7">
                            <slide v-for="card in restaurants" :key="card">
                                <div class="flex w-full flex-col mr-4">
                                    <figure
                                      class="w-full h-64"
                                    >
                                        <img
                                            class="rounded-t-lg w-full h-full object-cover"
                                            :src="card.media.length > 0 ? card.media[0].original_url : ''"
                                            :alt="card.media.length > 0 ? card.media[0].name : ''"
                                        >
                                    </figure>
                                    <div class="w-full bg-white rounded-b-lg p-2 lg:p-4">
                                        <h2 class="mt-3  text-md w-full lg:text-xl">
                                            {{ card.name }}
                                        </h2>
                                        <div class="mt-2 text-sm lg:text-md xl:flex justify-center">
                                            <p class="text-gray-600 flex items-center">
                                                <svg
                                                    width="12"
                                                    height="13"
                                                    class="mr-2"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M0.75 3.27177C0.75 2.61242 1.27233 2.0779 1.91667 2.0779H10.0833C10.7277 2.0779 11.25 2.61242 11.25 3.27177V10.435C11.25 11.0944 10.7277 11.6289 10.0833 11.6289H1.91667C1.27233 11.6289 0.75 11.0944 0.75 10.435V3.27177Z"
                                                        fill="white"
                                                    />
                                                    <path
                                                        d="M3.66667 3.27177V0.884033M8.33333 3.27177V0.884033M3.08333 5.65952H8.91667M1.91667 11.6289H10.0833C10.7277 11.6289 11.25 11.0944 11.25 10.435V3.27177C11.25 2.61242 10.7277 2.0779 10.0833 2.0779H1.91667C1.27233 2.0779 0.75 2.61242 0.75 3.27177V10.435C0.75 11.0944 1.27233 11.6289 1.91667 11.6289Z"
                                                        stroke="#01798A"
                                                        stroke-width="1.3166"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                              <formatted-date-range :from="card.start" :to="card.end" />
                                            </p>
                                            <p class="text-gray-600 flex items-center xl:ml-3">
                                                <svg
                                                    width="12"
                                                    height="13"
                                                    class="mr-2"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M9.30048 9.03628C8.88345 9.46304 8.11904 10.2453 7.4309 10.9494C6.6463 11.7523 5.35485 11.7522 4.57024 10.9493C3.89547 10.2588 3.14306 9.48883 2.70082 9.03628C0.878373 7.17134 0.878373 4.14768 2.70082 2.28274C4.52327 0.417798 7.47804 0.417798 9.30048 2.28274C11.1229 4.14768 11.1229 7.17134 9.30048 9.03628Z"
                                                        stroke="#01798A"
                                                        stroke-width="1.16667"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M7.75065 5.65951C7.75065 6.64854 6.96715 7.45031 6.00065 7.45031C5.03415 7.45031 4.25065 6.64854 4.25065 5.65951C4.25065 4.67047 5.03415 3.86871 6.00065 3.86871C6.96715 3.86871 7.75065 4.67047 7.75065 5.65951Z"
                                                        stroke="#01798A"
                                                        stroke-width="1.16667"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                                {{ card.place.area }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script setup>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import FormattedDateRange from "@/ComponentsDeprecated/Time/FormattedDateRange";
import { computed } from 'vue'

const props = defineProps({
  destinationId: {
    type: String
  },
  eateries: {
    type: Array,
    required: true,
  },
  headlines: {
    type: Object,
    required: true
  },
  pivotId: {
    type: Object,
    required: true
  }
});

const destination = props.eateries.filter(entry => entry.destination_id === props.destinationId )
const restaurants = destination.filter(eatery => eatery.type === 'eatery')

const headline = computed(() => {
  if (props.headlines?props.headlines[props.pivotId]:'') {
    return props.headlines[props.pivotId];
  } else {
    return 'Spisetsteder'
  }
})

</script>

